import React from 'react'
import AddPackingListMain from './addPackingListMain'

const AddPackingList = () => {
    return (
        <div>
            <AddPackingListMain editPacking={false} />
        </div>
    )
}

export default AddPackingList
